import { GridColDef } from '@mui/x-data-grid-pro';
import ActionCell from './components/ActionCell';
import CampaignCell from './components/CampaignCell';
import LineItemCell from './components/LineItemCell';
import SummaryCell from './components/SummaryCell';
import TimestampCell from './components/TimestampCell';

const COLUMNS: GridColDef[] = [
  {
    field: 'summary',
    headerName: 'Description of Change',
    display: 'flex',
    flex: 3.5,
    renderCell: SummaryCell,
  },
  {
    field: 'advertiserName',
    headerName: 'Advertiser',
    align: 'center',
    headerAlign: 'center',
    flex: 1.8,
    sortable: false,
  },
  {
    field: 'campaignName',
    headerName: 'Campaign',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    flex: 1.8,
    sortable: false,
    renderCell: CampaignCell,
  },
  {
    field: 'lineItemName',
    headerName: 'Line Item',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    flex: 1.8,
    sortable: false,
    renderCell: LineItemCell,
  },
  {
    field: 'createdAt',
    headerName: 'Timestamp',
    align: 'center',
    display: 'flex',
    renderCell: TimestampCell,
    headerAlign: 'center',
    maxWidth: 130,
    flex: 2,
  },
  {
    field: 'userName',
    headerName: 'User',
    flex: 2,
  },
  {
    field: 'userEmail',
    headerName: 'User Email',
    flex: 2,
  },
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    flex: 1,
    minWidth: 160,
    renderCell: ActionCell,
  },
];

export default COLUMNS;
